
export class Responsable {
  NombreCompleto: string;
  UserName: string;
  DNI: string;
  codigoUsuario?: string;
}
